module.exports = __webpack_public_path__ + "assets/images/flag-uk-abf520c71315b0a07d0e66da25674d35.png";